import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  setLocationsBySiteAction
} from '../../reducers/actions';
import { LocationService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_LOCATIONS_BY_SITE),
    switchMap(action =>
      LocationService.getBySiteId(action.siteId, store).pipe(
        map(data => setLocationsBySiteAction(data)),
        catchError(retryAuthentication(action$, 'epics/locations/getLocationsBySite'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/locations/getLocationsBySite.js